import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';

export class UndoRedoController
{
    public enableRecording():void
    {
        const {openDesign} = controllers.ui;

        openDesign.startWatchingDesignState();
    }

    public disableRecording():void
    {
        const {openDesign} = controllers.ui;

        openDesign.stopWatchingDesignState();
    }

    @action
    public undo():void
    {
        const {bindings, designSync, openDesign} = controllers.ui;

        const openDesignState = openDesign.getOpenDesign();
        if( !openDesignState || !openDesignState.initialized )
            return;

        this.disableRecording();

        designSync.undo();
        bindings.stopBinding();

        setTimeout(() =>
        {
            this.enableRecording();
        });
    }

    @action
    public redo():void
    {
        const {bindings, designSync, openDesign} = controllers.ui;

        const openDesignState = openDesign.getOpenDesign();
        if( !openDesignState || !openDesignState.initialized )
            return;

        this.disableRecording();

        designSync.redo();
        bindings.stopBinding();

        setTimeout(() =>
        {
            this.enableRecording();
        });
    }

    @action
    public clear():void
    {
        const {bindings, designSync, openDesign} = controllers.ui;

        const openDesignState = openDesign.getOpenDesign();
        if( !openDesignState || !openDesignState.initialized )
            return;

        designSync.clearUndoStack();
        bindings.stopBinding();
    }

    public get isUndoAllowed()
    {
        return controllers.ui.designSync.isUndoAllowed;
    }

    public get isRedoAllowed()
    {
        return controllers.ui.designSync.isRedoAllowed;
    }
}
